/* eslint-disable  */
import { BasePdfClient } from 'data-layer-cr/dist/network';

import {
  injectDefaultHeaders,
  injectAuthorization,
  injectNetworkErrorHandler,
} from './injectors';

BasePdfClient.defaults.baseURL = process.env.REACT_APP_BASE_URL;
BasePdfClient.interceptors.request.use(injectDefaultHeaders);
BasePdfClient.interceptors.request.use(injectAuthorization);
BasePdfClient.interceptors.response.use(
  (response) => response,
  injectNetworkErrorHandler,
);

export default BasePdfClient;
